import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import Month from './month';
import {
  DayPickerContainer,
  MonthSelector,
  MonthLabel,
  MonthSelectorLeftArrow,
  MonthSelectorRightArrow,
  ClearAllButton
} from './styles';
import { ArrowIcon } from '@spa/shared/svg';
import { useMonth } from '@spa/shared/hooks/dateRange';

export const Table = ({ dateRange }) => {
  const {
    startDate,
    onResetDates,
    activeMonths,
    isPresentActiveMonth,
    firstDayOfWeek,
    goToPreviousMonths,
    goToNextMonths
  } = dateRange;

  const { monthLabel, year } = useMonth({
    year: activeMonths[0].year,
    month: activeMonths[0].month,
    firstDayOfWeek
  });

  const { t } = useTranslation();

  return (
    <DayPickerContainer>
      <MonthSelector>
        <MonthSelectorLeftArrow onClick={goToPreviousMonths} className={isPresentActiveMonth && 'disabled'}>
          <ArrowIcon />
        </MonthSelectorLeftArrow>
        <MonthLabel>
          {`${monthLabel} `}
          <span>{year}</span>
        </MonthLabel>
        <MonthSelectorRightArrow onClick={goToNextMonths}>
          <ArrowIcon />
        </MonthSelectorRightArrow>
      </MonthSelector>
      {activeMonths.map(month => (
        <Month key={`${month.year}-${month.month}`} year={month.year} month={month.month} dateRange={dateRange} />
      ))}

      {startDate ? <ClearAllButton onClick={onResetDates}>{t('filters.labels.clearDates')}</ClearAllButton> : null}
    </DayPickerContainer>
  );
};

Table.propTypes = {
  dateRange: PropTypes.object.isRequired
};

export default Table;
